import axios from "axios";
import { tokenStorage } from "../lib/tokenStorage";
import { authEvents } from "../lib/authEvents";
import { apiErrorMessage } from "../lib/apiErrorMessage";

const baseURL = process.env.REACT_APP_API_URL || "";

// Cookie'yi sadece same-origin isteklerde gönderiyoruz. Panel oturumu zaten
// tokenStorage'daki Bearer token ile taşınıyor; API ise CORS'ta wildcard origin
// dönüyor ve tarayıcılar wildcard + credentials kombinasyonunu reddediyor.
// REACT_APP_API_URL ile farklı bir origin'e bağlanıldığında bu yüzden kapalı.
const isSameOrigin = !baseURL;

export const axiosInstance = axios.create({
  baseURL,
  timeout: 30000,
  withCredentials: isSameOrigin,
  // Sunucu sistem panosunda web / iOS / Android dağılımını buradan sayıyor.
  headers: { "X-Client": "web" },
});

axiosInstance.interceptors.request.use((config) => {
  const token = tokenStorage.get();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const axiosBaseQuery =
  () =>
  async ({ url, method, data, params, headers, timeout } = {}) => {
    try {
      // timeout: uzun süren istekler (toplu hedef atama) kendi süresini verir.
      const result = await axiosInstance({ url, method, data, params, headers, ...(timeout ? { timeout } : {}) });
      return { data: result.data };
    } catch (axiosError) {
      const status = axiosError.response?.status;
      const body = axiosError.response?.data;

      // Kullanıcıya gösterilecek metin tek noktadan üretiliyor; axios'un
      // İngilizce mesajları ("Network Error", "timeout of 30000ms exceeded")
      // ve sunucunun teknik mesajları buradan dışarı çıkmıyor.
      const message = apiErrorMessage({
        status,
        serverMessage: body?.message,
        errorType: body?.errorType,
        code: axiosError.code,
      });

      if (status === 401) {
        tokenStorage.clear();
        authEvents.emit("unauthorized", { message });
        return { error: { status: 401, message } };
      }

      if (status === 503 && body?.errorType === "MAINTENANCE") {
        return { error: { type: "MAINTENANCE", status: 503, message } };
      }

      return { error: { status: status || "FETCH_ERROR", message } };
    }
  };
